import { FileActions } from "./FileActions";
import { formatBytes } from "utils/formatBytes";
import { UploadProgress } from "./UploadProgress";
import { UploadedFile } from "../types/UploadedFile.type";
import { UploadStatus } from "../types/UploadStatus.type";
import { getFileTypeIcon } from "../utils";
import { Spinner } from "@chakra-ui/react";

interface FileCardProps {
	error?: Error | null;
	file: UploadedFile;
	isPreview?: boolean;
	isUploading?: boolean;
	progress?: number;
	onDelete: () => void;
	onCancel?: () => void;
	onRetry?: () => void;
}

/**
 * Displays the uploaded file, or pending uploaded file
 * @param param0
 * @returns
 */
export const FileCard: React.FC<FileCardProps> = ({
	file,
	progress = 0,
	isUploading = false,
	error,
	isPreview,
	onDelete,
	onCancel,
	onRetry,
}) => {
	const isDeleting = file.status === UploadStatus.DELETING;

	return (
		<div className={`group flex items-center justify-between rounded-lg border p-3 ${isDeleting ? "opacity-50" : ""}`}>
			<div className="flex items-center gap-3">
				<div className="flex-shrink-0">
					{getFileTypeIcon(file.name)}
				</div>
				<div className="flex flex-col">
					<span className="break-all text-sm font-semibold">{file.name}</span>
					{file.size && (
						<span className="text-xs text-gray-500">
							{formatBytes(file.size)}
						</span>
					)}
				</div>
			</div>

			<div className="flex items-center gap-3">
				{isDeleting && (
					<Spinner size="sm" color="red.500" />
				)}

				{(isUploading || error) && !isDeleting && (
					<UploadProgress
						progress={progress}
						error={!!error}
						onRetry={onRetry}
					/>
				)}

				{!isDeleting && (
					<FileActions
						hasErrored={!!error}
						isPreview={isPreview}
						isUploading={isUploading}
						filePath={file.path}
						fileName={file.name}
						onCancel={onCancel}
						onDelete={onDelete}
						onRetry={onRetry}
					/>
				)}
			</div>
		</div>
	);
};
